import { FC } from 'react';
import Language from './language';

const UserSettings: FC = () => {
  return <Language />;
};

export default UserSettings;
